import { AxiosError } from "axios";
import React, { Component } from "react";
import SubscriptionWrapper from "./SubscriptionWrapper";
import { postRequest } from "../../utils/httpRequest";
import { Errors, formErrors } from "../../utils/helpers";

interface FieldErrors {
  email?: string;
  first_name?: string;
}

interface Props {
  heading?: React.ReactNode;
  onSubscribed?: () => void;
  // Set by surfaces whose wording is editable in admin. Left undefined
  // everywhere else, which keeps the built-in copy.
  promise?: string | null;
  buttonLabel?: string;
}

interface State {
  captchaError: string;
  captChaToken: string;
  email: string;
  errors: FieldErrors;
  firstName: string;
  isSaving: boolean;
  subscribed: boolean;
  username: string;
}

// The newsletter signup form and its submit handling, shared by the home page
// section and the blog exit-intent popup. Callers own the surrounding chrome.
class NewsletterForm extends Component<Props, State> {
  unmounted = false;

  state: State = {
    captchaError: "",
    captChaToken: "",
    email: "",
    errors: {},
    firstName: "",
    isSaving: false,
    subscribed: false,
    username: "",
  };

  componentWillUnmount() {
    this.unmounted = true;
  }

  onFieldChange = (field: string, value: string) => {
    this.setState((state) => ({
      ...state,
      [field]: value,
    }));
  };

  onCaptchaChange = (token: string | null) => {
    this.setState({ captChaToken: token || "" });
  };

  onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const { captChaToken, email, firstName, username } = this.state;
    const subscriptionBody = {
      subscription: {
        username,
        first_name: firstName,
        email,
      },
      recaptcha_token: captChaToken,
    };
    const subscriptionUrl =
      username.length > 0 ? "/api/spam.json" : "/api/subscriptions.json";

    this.setState({ captchaError: "", errors: {}, isSaving: true });
    postRequest(subscriptionUrl, subscriptionBody)
      .then(() => {
        if (this.unmounted) return;

        this.setState(
          { isSaving: false, subscribed: true },
          this.props.onSubscribed,
        );
      })
      .catch((error: AxiosError<{ errors: Errors; captcha_error: string }>) => {
        if (this.unmounted) return;

        this.setState({
          captchaError: error.response?.data?.captcha_error || "",
          errors: formErrors(error.response?.data?.errors || []) as FieldErrors,
          isSaving: false,
        });
      });
  };

  render() {
    return (
      <SubscriptionWrapper
        captchaError={this.state.captchaError}
        email={this.state.email}
        errors={this.state.errors}
        heading={this.props.heading}
        promise={this.props.promise}
        buttonLabel={this.props.buttonLabel}
        firstName={this.state.firstName}
        isSaving={this.state.isSaving}
        onCaptchaChange={this.onCaptchaChange}
        onFieldChange={this.onFieldChange}
        onSubmit={this.onSubmit}
        subscribed={this.state.subscribed}
        username={this.state.username}
      />
    );
  }
}

export default NewsletterForm;
